<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list row-key="id" ref="list" unit="报价单" :expand-all-row="true" :page="page" @showRow="toggleRow"
      :show-checkbox="is_listDialog" :show-query="true" :query-params="params" :get-data-func="api.list"
      urlHash="business/sales/quotation" :temp-params="temParams">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button type="primary" v-if="show" @click="onCustomTable" icon="el-icon-s-tools" style="margin:30px 0 10px 0">
      明细项
    </el-button>
    <el-table 
      ref="table" :row-key="row => row.Prop" 
      :data="subList" v-if="show" 
      stripe border show-summary
      :summary-method="getSummaries"
      @selection-change="handleSelectionChange"> 
      <el-table-column type="selection" v-if="is_listDialog" width="55"/>
      <template v-for="(item,index) in tableColumns" >
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column 
            :key="`${item.Prop}-${index}`" :prop="item.Prop"
            v-if="(canPrice == true && 
            (
              item.Prop == 'PurchasePrice' || 
              item.Prop == 'SalePrice' ||
              item.Prop == 'RetailPrice' ||
              item.Prop == 'QuotedPrice' ||
              item.Prop == 'Discount' ||
              item.Prop == 'TaxRate' ||
              item.Prop == 'Price' ||
              item.Prop == 'TaxPrice' ||
              item.Prop == 'Amount' ||
              item.Prop == 'TaxLimit' ||
              item.Prop == 'TaxAmount' ||
              item.Prop == 'DiscountAmount' 
            )
            ) || (
              item.Prop != 'PurchasePrice' &&
              item.Prop != 'SalePrice' &&
              item.Prop != 'RetailPrice' &&
              item.Prop != 'QuotedPrice' &&
              item.Prop != 'Discount' &&
              item.Prop != 'TaxRate' &&
              item.Prop != 'Price' &&
              item.Prop != 'TaxPrice' &&
              item.Prop != 'Amount' &&
              item.Prop != 'TaxLimit' &&
              item.Prop != 'TaxAmount' &&
              item.Prop != 'DiscountAmount' 
            )"
            :label="item.Label" 
            :align="item.Align ?? 'left'" 
            :min-width="item.Width"
            show-overflow-tooltip
          >
          <template slot-scope="{row}">
            <span v-if="item.Prop == 'Amount' || item.Prop == 'TaxLimit' || item.Prop == 'TaxAmount' || item.Prop == 'DiscountAmount' || item.Prop == 'SaQuantity' || item.Prop == 'Quantity2' || item.Prop == 'Price' || item.Prop == 'QuotedPrice'">
              {{$commonJs.toThousands(row[item.Prop]) }}
            </span>
            <span v-else>{{row[item.Prop] }} </span>
          </template>
        </el-table-column>
        </template>
      </template>
    </el-table>
    <!-- <el-table class="subItem-table" tooltip-effect="dark" :data="subList" v-if="show"
      @selection-change="handleSelectionChange" border>
      <el-table-column type="selection" v-if="is_listDialog" width="55">
      </el-table-column>
      <el-table-column align="left" label="存货名称" min-width="140px" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ row.ProductName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="存货编码" min-width="140px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductNo }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="规格型号">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="颜色" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销售单位">
        <template slot-scope="{ row }">
          <span>{{ row.SaUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.SaQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="计量单位2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.UnitName2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="数量2">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="换算率">
        <template slot-scope="{ row }">
          <span>{{ row.Rate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税进价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.PurchasePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税售价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.SalePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最低售价" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.RetailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.QuotedPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxLimit) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData='tableColumns' tableType='报价单明细'/>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

import tableColumn from "@/data/business/sales/quotation/list.json";
import tableParam from "@/data/business/sales/quotation/query.json";

export default {
  mixins: [listMixin],
  components: { list,customTableDialog },
  data() {
    return {
      api: require("@/api/sa/quotation").default,
      ProductApi: require("@/api/sa/quotationProduct").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      show: false,
      OrderNo: "",
      Address: "",
      TradeUnitId: 0,
      FullName: "",
      TransportId: 0,
      subList: [],
      subSelectList: [],
      params: {},
      temParams: {},
      tableColumns: [],
    };
  },
  props: {
    is_listDialog: {
      typeof: Boolean,
      default: true,
    },
    tempParams: {
      typeof: Object,
      default: () => { },
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  mounted() {
    if (!this.$permission.canPrice("/business/sales/quotation")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(
        (item) => item.tableName == "Amount"
      );
      list.tableList.splice(findIndex, 1);
    }
  },
  activated() {
    this.getRouterInfo();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/sales/quotation");
    },
  },
  methods: {
    onSave(data){
      this.getTableColumns()
      this.$message.success('保存成功')
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    async getTableColumns(){
      const res = await this.FieldSettingApi.list({Type: "报价单明细"})
      this.tableColumns = [] 
      this.tableColumns = res.Data
    },
    onCustomTable(){
      this.$refs.customTableDialog.dialogVisible = true
    },
    
    getRouterInfo() {
      console.log(
        this.$router.history.current.params,
        "this.$router.history.current.params"
      );
      if (this.$router.history.current.params) {
        this.temParams.Ids = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.Ids,
        };

        this.temParams.SourceType = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceType,
        };
        this.$refs.list.getData();
      }
    },
    toggleRow(data) {
      // if(!this.is_listDialog) return;
      this.show = false;
      this.Address = data.Address;
      this.api.info(data.QuotationId).then((res) => {
        if (res.Code === 0 && res.Data.length != 0) {
          this.show = true;
          this.OrderNo = res.Data.DocNo;

          this.TradeUnitId = res.Data.TradeUnitId;
          this.FullName = res.Data.TradeUnitName;
          this.TransportId = res.Data.TransportId;
          console.log(res.Data, "res.Data");

          if (this.isSelect) {
            res.Data.ProductModels.forEach((item) => {
              item.SaQuantity =
                item.SaQuantity - (item.SaOrderOccupyQuantity ?? 0);
              item.Amount = item.SaQuantity * item.Price;
              item.TaxAmount = item.SaQuantity * item.TaxPrice;
            });

            let tList = res.Data.ProductModels.filter((item) => {
              return item.SaQuantity > 0;
            });
            console.log("tList", tList);
            this.subList = tList;
          } else {
            this.subList = res.Data.ProductModels;
          }
        }
      });

      this.getTableColumns()

      // this.OrderNo = data.DocNo;
      // this.subList = data.ProductModels;
      // if (this.subList.length > 0) this.show = true;
    },
    // 非分页 千位符+保留后两位 普通合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const fieldNames = columns.map(col => col.property);
      fieldNames.forEach((field, index) => {
        if (field && ['SaQuantity','Quantity2','Amount','TaxLimit','TaxAmount','DiscountAmount','QuotedPrice'].includes(field)) {
          const values = data.map(item => Number(item[field]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); 
          } else {
            sums[index] = '/';
          }
        } else {
          sums[index] = '';
        }
      });
      sums[0] = '合计';
      return sums;
    },
    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 15px;
}
</style>
